import clsx from "clsx";
import { useMemo } from "react";

import { Product } from "@transfr-inc/dashboard-components/constants";

import { getProductBanner } from "@lib/product.utils";

import "./dashboard.hero.scss";

export function DashboardHero({ product }) {
  const heroImage = getProductBanner(product);

  const heroElement = useMemo(() => {
    if (product === Product.TRK) {
      return (
        <>
          <svg
            width="100%"
            height="100%"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
          >
            <circle
              cx="50%"
              cy="0"
              r="45%"
              stroke="#089DD4"
              strokeWidth="5"
              strokeDasharray="18 10"
            />
          </svg>
          <img src={heroImage} alt="banner hero" />
        </>
      );
    } else {
      return <img src={heroImage} alt="banner hero" />;
    }
  }, [product]);

  return (
    <div className={clsx("dashboard-hero-container", `product-${product}`)}>
      {heroElement}
    </div>
  );
}
